export default __webpack_public_path__ + "static/media/414.bc0f4c2f.png";